<div class="modal-header">
  <h5 class="modal-title">Kartı Kırp<span *ngIf="sideText"> — {{ sideText }}</span></h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <div class="text-muted small mb-2">
    Çerçeveyi kartın kenarlarına oturtun. Kırpılan görsel yalnızca okuma için kullanılır; yüklenen kimlik belgesi değişmez.
  </div>
  <div class="alert alert-danger py-2 small" *ngIf="loadFailed">Görsel açılamadı.</div>
  <image-cropper [imageFile]="file" [maintainAspectRatio]="false" [canvasRotation]="rotation" format="png"
    (imageCropped)="onCropped($event)" (loadImageFailed)="loadFailed = true">
  </image-cropper>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary me-auto" (click)="rotate()">
    <i class="mdi mdi-rotate-right me-1"></i>Döndür
  </button>
  <button type="button" class="btn btn-light" (click)="activeModal.dismiss()">Vazgeç</button>
  <button type="button" class="btn btn-primary" [disabled]="!cropped" (click)="confirm()">Kırpılanı Oku</button>
</div>
